import { NavigationCombined } from './type';

export const lpg = (internal: boolean, urlPrefix = ''): NavigationCombined => {
  return {
    order: 1,
    app: 'lpg',
    label: 'LPG',
    icon: 'propane_tank',
    flat: false,
    prefix: 'lpg',
    title: 'LPG',
    children: [
      {
        label: 'Capture',
        link: !internal ? `${urlPrefix}/g/lpg/capture` : null,
        route: internal ? ['/', 'lpg', 'capture'] : null,
        icon: 'insert_drive_file',
      },
      {
        label: 'Alerts',
        route: internal ? ['/', 'lpg', 'alerts'] : null,
        link: !internal ? `${urlPrefix}/g/lpg/alerts` : null,
        icon: 'add_alert',
        disabled: false,
      },
    ],
  };
};
